import React from "react";

export interface GpsProps {
    coordinates: string;
}
export function Gps(props: GpsProps) {
    const xy = props.coordinates.split(' ');
    return <span>{xy[1]}, {xy[0]}</span>;
}
